import React, { useState, useCallback } from 'react';
import { uploadType } from '../Constants';
import { FormControlLabel, Radio, RadioGroup, Typography } from '@mui/material';
import FileManager from '../components/Common/FileManager';

interface FileType {
  id: number;
  displayName: string;
  show: boolean;
  apiAction: string;
  renderType: number;
  adminOnly: boolean;
}
const FileEditor: React.FC = () => {
  const [fileTypes, setFileTypes] = useState<FileType[]>(fileTypesDefaults);

  const toggleFileType = useCallback(
    (typeId: number) => {
      const updatedFileTypes = fileTypes.map((ft) => ({
        ...ft,
        show: ft.id === typeId,
      }));
      setFileTypes(updatedFileTypes);
    },
    [fileTypes]
  );

  const fileType = fileTypes.find((ft) => ft.show);
  return (
    <div className='FileManager'>
      <Typography variant='h5'>File Details Editor</Typography>
      <div>
        <RadioGroup row>
          {fileTypes.map((type) => (
            <FormControlLabel
              key={type.id}
              control={<Radio onClick={() => toggleFileType(type.id)} />}
              checked={type.show}
              label={type.displayName}
            />
          ))}
        </RadioGroup>
      </div>
      {fileType && <FileManager isModal={false} fileTypeId={fileType.id} />}
    </div>
  );
};

export default FileEditor;

const fileTypesDefaults = [
  {
    id: uploadType.image,
    displayName: 'Images',
    show: true,
    apiAction: 'Image',
    renderType: uploadType.image,
    adminOnly: false,
  },
  {
    id: uploadType.audio,
    displayName: 'Mp3s',
    show: false,
    apiAction: 'Audio',
    renderType: uploadType.audio,
    adminOnly: false,
  },
  {
    id: uploadType.video,
    displayName: 'Videos',
    show: false,
    apiAction: 'Video',
    renderType: uploadType.video,
    adminOnly: true,
  },
  {
    id: uploadType.poster,
    displayName: 'Video Posters',
    show: false,
    apiAction: 'VideoPoster',
    renderType: uploadType.poster,
    adminOnly: true,
  },
  // {
  //   id: uploadType.liveLoungeVideo,
  //   displayName: 'Live Lounge Videos',
  //   show: false,
  //   apiAction: 'Video',
  //   renderType: uploadType.video,
  //   adminOnly: false,
  // },
  {
    id: uploadType.youtube,
    displayName: 'YouTube Videos',
    show: false,
    apiAction: 'YouTubeVideo',
    renderType: uploadType.youtube,
    adminOnly: false,
  },
];
